export default {
    miningWeeklyRewards: {
        title: 'Mining Settlements',
        detailTitle: 'Period Detail',
        empty: 'No data',
        back: 'Back',
        period: {
            weekN: 'Week',
            range: 'Period',
            userCount: 'Users',
            recordCount: 'Records',
            actualOutput: 'Actual Output (STORY)',
            scaled: 'Scaled',
            status: 'Status',
            autoReleaseAt: 'Auto Release At',
            approvedAt: 'Released At',
            overview: 'Period Overview',
        },
        status: {
            pending: 'Settling',
            approved: 'Released',
        },
        columns: {
            userId: 'User ID',
            rewardType: 'Reward Type',
            weekN: 'Week',
            nominalOutput: 'Nominal Output',
            actualOutput: 'Actual Output',
            fromUserId: 'From User ID',
            auditStatus: 'Release Status',
            auditBy: 'Released By',
            auditRemark: 'Audit Remark',
            auditAt: 'Released At',
            createdAt: 'Created At',
            action: 'Actions',
        },
        search: {
            userId: 'User ID',
            rewardType: 'Reward Type',
            auditStatus: 'Audit Status',
        },
        auditStatus: {
            pending: 'Pending',
            audited: 'Released',
        },
        rewardType: {
            mining: 'Dispatch Earnings',
            invite: 'Invite Earnings',
        },
        actions: {
            viewDetail: 'Detail',
            release: 'Release',
            released: 'Released',
            batchRelease: 'Batch Release',
            releasePeriod: 'Release Period',
            export: 'Export',
        },
        export: {
            success: 'Export queued. Check Downloads when ready.',
            missingWeek: 'Missing week number',
        },
        audit: {
            approveTitle: 'Batch Release ({count})',
            approvePeriodTitle: 'Confirm Period Release',
            approvePeriodContent:
                'Release mining settlements for period {range}? Users in this period will be able to claim rewards.',
            selected: '{count} selected',
            noSelection: 'Please select pending records first',
            noPending: 'No pending records in this period',
            auditByPlaceholder: 'Auditor (optional)',
            auditRemarkPlaceholder: 'Audit remark (optional)',
            memo: 'Memo',
            memoPlaceholder: 'Memo (optional, applied to selected rows)',
            rewardHint:
                'You can edit actual output for pending rows; unchanged rows keep the original value on release',
        },
    },
};
